import heroThumb from "../../assets/images/all-img/v2/hero-thumb.png";
export default function HeroThumbSection() {
	return (
		<div className="section bg-warning-200">
			<div className="container">
				<div className="fugu-single-thumb wow fadeInUpX" data-wow-delay="0.20s">
					<img src={heroThumb} alt="" />
				</div>
			</div>
		</div>
	);
}
